(function (root, factory) {
  const api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  root.MobyPriceFormat = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  const currencyLocales = {
    SEK: 'sv-SE',
    NOK: 'nb-NO',
    DKK: 'da-DK',
  };

  function normalizeCurrencyOutput(value) {
    return value.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function getFormatterLocale(currency, locale) {
    return currencyLocales[currency] || locale || 'en';
  }

  function formatPerServing(cents, options = {}) {
    const currency = options.currency || 'SEK';
    const locale = getFormatterLocale(currency, options.locale);
    const label = options.label || ' per serving';
    const amount = cents / 100 / 30;

    const formattedAmount = normalizeCurrencyOutput(
      new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount)
    );

    return `${formattedAmount}${label}`;
  }

  return {
    formatPerServing,
  };
});
